import { isString } from "lodash-es";
import { WorkAssignment } from "@bluecrew/crew-member-backend-angular-client";
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

import { ActiveDays } from "../common/working-days-of-week/working-days-of-week.component";

export const formatWage = (wage: string | number): string => {
    if (isString(wage)) return wage;
    return '$' + wage.toFixed(2) + '/hr';
};

export const formatDate = (time: dayjs.Dayjs) => {
  return `${time.format('ddd, MMM D, YYYY')}`;
}

export const formatDateNoYear = (time: dayjs.Dayjs) => {
  return `${time.format('ddd, MMM D')}`;
}

export const formatDateFromString = (time: string) => {
  return dayjs(time).format('ddd MMM D, YYYY')
}

export const formatDateNoDay = (time: dayjs.Dayjs) => {
  return `${time.format('MMM D, YYYY')}`;
}

export const formatISODate = (time: dayjs.Dayjs) => {
  return `${time.format('YYYY-MM-DD')}`;
}

export const formatDateAndTimeFromString = (time: string) => {
  return formatDateAndTime(dayjs(time));
}

export const formatDateAndTime = (time: dayjs.Dayjs) => {
  return time.format('MMM D h:mm A');
}

export const formatDateRange = (start: dayjs.Dayjs, end: dayjs.Dayjs) => {
    if (start.year() !== end.year()) {
      return `${start.format('MMM D YYYY')} - ${end.format('MMM D YYYY')}`;
    }
    if (start.month() !== end.month()) {
      return `${start.format('MMM D')} - ${end.format('MMM D')}, ${start.format('YYYY')}`;
    }
    if (start.date() !== end.date()) {
      return `${start.format('MMM')} ${start.format('D')} - ${end.format('D')}, ${start.format('YYYY')}`;
    }
    return `${start.format('MMM D YYYY')}`;
}

export const formatTime = (time: dayjs.Dayjs) => {
  return `${time.format('h:mm A')}`;
}

export const formatISOTime = (time: dayjs.Dayjs) => {
  return `${time.format('HH:mm:ss')}`;
}

export const formatTimeRange = (start: dayjs.Dayjs, end: dayjs.Dayjs) => {
    return `${start.format('h:mma')} - ${end.format('h:mma')}`;
}

export const normalizeActiveDays = (daysOfWeek: WorkAssignment.DaysOfWeekEnum[]): ActiveDays => {
    const activeDays: ActiveDays = {};
    daysOfWeek.forEach(d => activeDays[d] = true);
    return {
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
      ...activeDays,
    };
}

export const millisecondsToHHMM = (milliseconds: number): string => {
    var seconds = milliseconds / 1000;
    var hours = Math.floor(seconds / 3600);
    seconds = seconds % 3600;
    var minutes = Math.floor(seconds / 60);
    seconds = seconds % 60;
    var hourString = hours > 0 ? hours + 'h ' : '';
    var minuteString = minutes + 'm';
    return hourString + minuteString;
}

export const normalizeActiveDaysFromApiV1 = (workdays: boolean[]): ActiveDays => {
  const indexToDay = {
    0: 'sunday',
    1: 'monday',
    2: 'tuesday',
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday'
  };
  const out: ActiveDays = {};
  for (let i = 0; i < workdays.length; i++) {
    out[indexToDay[i]] = workdays[i];
  }
  return out;
};

export const formatDuration = (durationInMinutes: number): string => {
  const hours = Math.floor(durationInMinutes / 60);
  const minutes = durationInMinutes % 60;
  if (hours > 0 && minutes === 0) {
    return `${hours} hr`;
  }
  return hours > 0 ? `${hours} hr ${minutes} min` : `${minutes} min`;
};

// Returns "X hour/s and X minute/s" between current time and given timestamp
export const formatHoursMinutesTextUntilTime = (timestamp: string): string => {
  let minutes = dayjs(timestamp).diff(dayjs(), 'minute');
  const hours = Math.floor(minutes / 60);
  minutes -= hours * 60;
  let hoursMinutesText = '';
  if (hours) {
    hoursMinutesText += `${hours} hour${hours > 1 ? 's' : ''}`
  }
  if (minutes) {
    hoursMinutesText += `${hours ? ' and ' : ''}${minutes} minute${minutes > 1 ? 's' : ''}`
  }
  return hoursMinutesText;
}
